import { getQrSession, getQrCsrf, isQrVisit } from './qrNavigation';

export const attachQrSession = config => {
  const data = config.data;
  if (!data || typeof data !== 'object' || !data.tokenqr) return config;
  if (isQrVisit(data.tokenqr)) {
    config.withCredentials = true;
    const csrf = getQrCsrf(data.tokenqr);
    if (csrf) config.headers = { ...config.headers, 'X-QR-CSRF': csrf };
  } else if (/(?:home_page|token)\.php(?:\?|$)/.test(config.url || '')) return config;
  const session = getQrSession(data.tokenqr);
  if (session?.token && !Object.prototype.hasOwnProperty.call(data, 'token')) {
    config.data = { ...data, token: session.token };
  }
  return config;
};

const INVALID_QR_CODES = new Set([
  'INVALID_QR_CONTEXT',
  'QR_CONTEXT_INVALID',
  'QR_TOKEN_INVALID',
  'ORDER_QR_SESSION_INVALID',
  'ORDER_QR_CSRF_INVALID',
  'ORDER_QR_BROWSER_SESSION_INVALID',
]);

export const shouldRedirectToInvalidQr = (error) => {
  if (Number(error?.response?.status) !== 403) return false;
  // The route guard owns bootstrap failures; a second document navigation can interrupt the next scan.
  const requestPath = String(error?.config?.url || '').split(/[?#]/)[0];
  if (/(?:^|\/)browser_session\.php$/.test(requestPath)) return false;
  const payload = error?.response?.data || {};
  const code = String(
    payload?.core_error?.code || payload?.error || payload?.msg || ''
  ).toUpperCase();
  return INVALID_QR_CODES.has(code);
};
